module.exports = __webpack_public_path__ + "img/step1-en.79c24545.webp";